import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";

const Contact = () => {
  return (
    <section id="contact" className="w-full pt-20 md:pt-32">
      <div className="mb-12 md:mb-20 flex flex-col justify-start gap-4 border-b border-black/10 dark:border-white/10 pb-8">
        <span className="text-[13px] md:text-sm font-mono text-black/50 dark:text-white/50 uppercase tracking-widest">
          Contact
        </span>
        <h2 className="text-3xl sm:text-4xl md:text-[42px] font-display font-medium tracking-[-0.02em] leading-tight text-black dark:text-white max-w-2xl">
          Let's build something.
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
        {/* Left: Text */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col"
        >
          <h2 className="text-[12vw] sm:text-[10vw] md:text-6xl lg:text-[80px] font-display font-medium tracking-[-0.04em] mb-8 leading-[0.9] text-black dark:text-white">
            Ready to <br />
            <span className="text-transparent [-webkit-text-stroke:1px_rgba(0,0,0,0.4)] dark:[-webkit-text-stroke:1px_rgba(255,255,255,0.4)]">
              collaborate?
            </span>
          </h2>
          <p className="text-black/60 dark:text-white/60 mb-16 max-w-md leading-relaxed font-mono text-sm">
            {
              "// Open for full-time roles, freelance contracts, and consulting. I respond within 24 hours."
            }
          </p>

          <div className="flex flex-col gap-6 md:gap-8">
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-0">
              <span className="w-full md:w-32 text-emerald-600 dark:text-emerald-500 font-mono text-xs uppercase tracking-widest">
                Email
              </span>
              <a
                href="mailto:adepejuifeoluwa97@gmail.com"
                className="text-base sm:text-lg md:text-xl font-display font-medium tracking-tight text-black/80 dark:text-white/80 hover:text-black dark:hover:text-white transition-colors duration-300 break-all sm:break-normal"
              >
                adepejuifeoluwa97@gmail.com
              </a>
            </div>
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-0">
              <span className="w-full md:w-32 text-emerald-600 dark:text-emerald-500 font-mono text-xs uppercase tracking-widest">
                Phone
              </span>
              <a
                href="tel:+2348149735987"
                className="text-base sm:text-lg md:text-xl font-display font-medium tracking-tight text-black/80 dark:text-white/80 hover:text-black dark:hover:text-white transition-colors duration-300"
              >
                +234 814 973 5987
              </a>
            </div>
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-0">
              <span className="w-full md:w-32 text-emerald-600 dark:text-emerald-500 font-mono text-xs uppercase tracking-widest">
                LinkedIn
              </span>
              <a
                href="https://www.linkedin.com/in/adepejuifeoluwa/"
                target="_blank"
                rel="noreferrer"
                className="text-base sm:text-lg md:text-xl font-display font-medium tracking-tight text-black/80 dark:text-white/80 hover:text-black dark:hover:text-white transition-colors duration-300 break-all sm:break-normal"
              >
                linkedin.com/in/adepejuifeoluwa
              </a>
            </div>
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-0">
              <span className="w-full md:w-32 text-emerald-600 dark:text-emerald-500 font-mono text-xs uppercase tracking-widest">
                Github
              </span>
              <a
                href="https://github.com/Adepejustephen"
                target="_blank"
                rel="noreferrer"
                className="text-base sm:text-lg md:text-xl font-display font-medium tracking-tight text-black/80 dark:text-white/80 hover:text-black dark:hover:text-white transition-colors duration-300 break-all sm:break-normal"
              >
                github.com/Adepejustephen
              </a>
            </div>
          </div>
        </motion.div>

        {/* Right: Calendly CTA */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="bg-gray-200/50 dark:bg-[#0a0a0a]/50 rounded-3xl p-8 md:p-12 border border-black/5 dark:border-white/5 flex flex-col justify-center items-start lg:max-w-md mx-auto w-full"
        >
          <h3 className="text-xl md:text-2xl font-display font-medium tracking-tight mb-6 text-black dark:text-white">
            Skip the email. <br /> Let's talk directly.
          </h3>
          <p className="text-black/60 dark:text-white/60 mb-10 leading-relaxed font-mono text-sm max-w-md">
            {
              "// Grab a 30-minute slot on my calendar to discuss your project, architecture, or potential roles."
            }
          </p>

          <a
            href="https://calendly.com/adepejuifeoluwa97"
            target="_blank"
            rel="noreferrer"
            className="group flex items-center text-[13px] md:text-sm justify-between w-full bg-black dark:bg-white text-white dark:text-black px-6 py-4 font-display font-medium tracking-widest hover:bg-black/80 dark:hover:bg-white/80 transition-colors duration-300 rounded-full"
          >
            <span>Book a Session</span>
            <div className="w-8 h-8 rounded-full bg-white/10 dark:bg-black/10 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <ArrowUpRight size={14} />
            </div>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
